<template>
  <material-card
    :hideBar="hideBar"
    :title="title || config.title"
    :text="subtitle"
    color="primary"
    class="elevation-1">

    <!-- embedded upsert dialog -->
    <v-dialog
      v-if="!hideUpsert && $can('read', entityName) && config.upsert !== 'full' && openUpsert"
      v-model="openUpsert"
      :max-width="upsertMaxWidth">
      <slot name="upsert">
        <app-upsert
          v-if="openUpsert"
          :title="upsertTitle || config.title || title || entityName"
          :item="item || hiddenFields"
          :config="config"
          :subtitle="subtitle"
          :apiUpsert="apiUpsert"
          :apiGetdetail="apiGetdetail"
          :readonly="!$can('upsert', entityName)"
          modal
          @saved="upsertSaved"
          @close="openUpsert=false" />
      </slot>
    </v-dialog>

    <!-- TODO: should put a slot header here -->
    <template slot='headerActions'>
      <slot name='headerActions'/>
          <v-tooltip
            top>
            <template
              slot="activator"
              slot-scope="{ on }">

                <v-btn
                v-if="!hideUpsert && !hideCreate && $can('upsert', entityName)"
                color="secondary"
                @click="upsertAction()" v-on="on">
                <v-icon >mdi-plus</v-icon>
              </v-btn>
            
            </template>
            <span>Add new {{entityName}}</span>
          </v-tooltip>
    </template>

    <!-- embedded inline upsert, should use Upsert  -->
    <v-form
      class='mt-2'
      v-if="inlineUpsert"
      ref="form"
      v-model="validForm">
      <v-container grid-list-md style="max-width:1450px">
        <v-layout wrap>
          <core-field
            v-for="field in fields"
            :readonly="readonly || (typeof field.readonly === 'function' ? field.readonly(item, $store.state) : field.readonly)"
            :key="field.value"
            :field="field"
            :item="item"
            v-model="item[field.value]" />
        </v-layout>
        <v-btn
          :disabled="!validForm"
          class="mx-1 font-weight-light"
          color="success"
          small
          @click="save">Save</v-btn>
      </v-container>
    </v-form>

    <v-data-table
      style="width: 100%"
      :items="items"
      :headers-length="headers.length"
      :loading="loading"
      :hide-default-footer="totalItems<=pagination.itemsPerPage"
      :options='pagination'
      @_update:options='p => pagination = p'
      @update:items-per-page="p => { pagination.itemsPerPage = p; getData()}"
      @update:page='p => { pagination.page = p; getData()}'
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-text': !isMobile ? 'Rows per page' : 'x page',
        'items-per-page-options': [5, 10, 20]
      }"
    >

      <template
        slot="header">
        <thead class='v-data-table-header'>
          <tr v-if="!isMobile">
            <th
              v-for="header in headers"
              :key="header.value"
              :class="[
                'column',
                header.table.align ? 'text-' + header.table.align : 'text-start',
                pagination.descending ? 'desc' : 'asc',
                header.table.sortable !== false && 'sortable',
                header.value === pagination.sortBy && header.table.sortable != false && 'active'
              ]"
              @click="changeSort(header)">
              <span
                class="text--lighten-4"> {{header.text}}
                <v-icon class="v-data-table-header__icon"
                  v-if="header.table.sortable !== false && pagination.sortBy === header.value"
                  small>mdi-arrow-up
                </v-icon>
              </span>

            </th>
          </tr>
          <tr class="lighten-3" v-if="!noSearch && !isMobile">
            <th
              v-for="header in headers"
              :key="header.value">
              <div v-if="header.table.filter" :style="{ 'max-width': `${ header.table.width || 200}px` }">
                
                <v-text-field
                  class='pt-0 mt-0'
                  v-if="header.type === 'text' || !header.type"
                  v-model="localFilters[header.value]"
                  :placeholder="header.table.filter.placeholder || 'Search'"
                  @input='() => getData(true)'
                  clearable
                  md4
                />

                <v-select
                  v-if="header.type === 'list'"
                  v-model="localFilters[header.value]"
                  :items="list(header.list)"
                  :item-text="header.title || 'name'"
                  :item-value="header.id || 'id'"
                  :placeholder="header.table.filter.placeholder || 'Select'"
                  @input='() => getData(true)'
                  clearable
                  md4
                  class="pt-0 mt-0"
                />
                
                <v-text-field
                  class='pt-0 mt-0'
                  v-if="header.type === 'autocomplete'"
                  v-model="localFilters[header.value]"
                  :placeholder="header.table.filter.placeholder || 'Search'"
                  @input='() => getData(true)'
                  clearable
                  md4
                />

                <v-menu
                  v-if="header.type === 'date'"
                  v-model="header.datepicker"
                  :placeholder="header.table.filter.placeholder || 'Search'"
                  :close-on-content-click="true"
                  :nudge-right__="40"
                  lazy_
                  transition="scale-transition"
                  offset-y_
                  full-width_
                  style="max-width:100px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    class='pt-0 mt-0'
                      clearable
                      v-model="localFilters[header.value]"
                      :placeholder="header.table.filter.placeholder || 'Search'"
                      readonly
                      @input='() => getData(true)'
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    dark
                    v-model="localFilters[header.value]"
                    no-title
                    @input='() => getData(true)'
                    
                  ></v-date-picker>
                </v-menu>


                 <core-datetime-picker 
                  v-model="localFilters[header.value]"
                  v-if="header.type === 'datetime'"
                  :label="header.table.filter.placeholder || 'Search'"
                  :disabled="readonly"
                  clearable
                  @input='() => getData(true)'
                  />

                <!-- <core-field
                  v-if="header.type === 'autocomplete'"
                  select
                  :field="{
                    value: header.value,
                    text: header.text,
                    id: header.id,
                    filter: header.filter,
                    reference: header.reference,
                    title: header.title,
                    subtitle: header.subtitle,
                    type: 'autocomplete',
                    placeholder: 'Select',
                    full: true,
                  }"
                  v-model='localFilters[header.value]'
                  @input='() => getData(true)' /> -->

                <v-select
                  style="width: 100px;"
                  v-if="header.type === 'check'"
                  v-model="localFilters[header.value]"
                  :items="[{ text: 'True', value: 1 },{ text: 'False', value: 0 }]"
                  :placeholder="header.table.filter.placeholder || 'Select'"
                  @input="() => getData(true)"
                  clearable
                  md4
                  class="mt-0 pt-0"
                />

              </div>
            </th>
          </tr>
          <tr v-if="isMobile">
            <th>
              <!-- @TODO search -->
            </th>
          </tr>
        </thead>
      </template>

      <template
        slot="item"
        slot-scope="{ item }">
        <tr v-if="!isMobile">
          <td
            v-for="header in headers"
            :key="header.value"
            class="text-left">

            <div style='min-width: 90px;padding-right:10px' v-if="header.value === 'actions'" class="text-right">
              <span  v-for="(action, id) in actions" :key="'act_'+id">
              <v-tooltip
                color="white"
                v-if='typeof action.disable !== "function" || !action.disable(item)'
                top>
                <template
                  slot="activator"
                  slot-scope="{ on }">
                  <a
                    :class="{ 'ml-2': id !== 0 }"
                    flat
                    @click="evt => doAction(action, item, evt)">
                    <v-icon
                      :color="action.color"
                      v-on="on">{{ action.icon }}</v-icon>
                  </a>
                </template>
                <span>{{ action.text }}</span>
              </v-tooltip>
              </span>
            </div>

            <span v-if="header.render">
              <div v-if="header.tooltip && header.tooltip(item)">
                <v-tooltip
                    color="white"
                    top>
                    <template
                      slot="activator"
                      slot-scope="{ on }">
                      <span v-if="header.click" style="cursor: pointer" v-on="on" @click="header.click(item)">{{header.render(item)}}</span>
                      <span v-if="!header.click" v-on="on">{{header.render(item)}}</span>
                    </template>
                    <span>{{header.tooltip(item)}}</span>
                  </v-tooltip>
              </div>
              <div v-else>
                <div v-if="header.click" pointer style="cursor: pointer" v-html="header.render(item)" @click="header.click(item)"></div>
                <div v-if="!header.click" v-html="header.render(item)"></div>
              </div>
            </span>

            <span v-else-if="header.type === 'autocomplete'">
              <!-- {{header.value}} {{header.reference}} {{item}} -->
              <!-- TODO! -->
              {{ getAutocompleteValue(header, item) }}
            </span>
            <span v-else-if="header.type === 'check'">
              <v-icon v-if="item[header.value] && item[header.value] !== '0'" color='green'>mdi-check</v-icon>
              <v-icon v-else color='red'>mdi-close</v-icon>
            </span>
            <span v-else>

              <div v-if="header.tooltip && header.tooltip(item)">
                <v-tooltip
                    color="white"
                    top>
                    <template
                      slot="activator"
                      slot-scope="{ on }">
                      <span v-if="header.click" v-on="on" style="cursor: pointer" @click="header.click(item)">{{item[header.value]}}</span>
                      <span v-if="!header.click" v-on="on">{{item[header.value]}}</span>
                    </template>
                    <span>{{header.tooltip(item)}}</span>
                  </v-tooltip>
              </div>

              <div v-else>
                <div v-if="header.click" v-html="item[header.value]"  style="cursor: pointer" @click="header.click(item)"></div>
                <div v-if="!header.click" v-html="item[header.value]"></div>
              </div>
              
            </span>

          </td>

        </tr>
        <tr v-if="isMobile">
          <td class="text-left">
            <table border="0" style="width: 100%">
              <tr>
                <td>
                  <br>
                  <p
                    v-for="header in headers"
                    :key="header.value"
                    class="flex-item"
                    data-label="Name"
                  >
                    <b v-if="header.value !== 'actions'">{{ header.text }} : </b>

                    <span v-if="header.render && header.click" v-html="header.render(item)" @click="header.click(item)">
                    </span>
                    <span v-else-if="header.render && !header.click" v-html="header.render(item)">
                    </span>
                    <span v-else-if="header.type === 'autocomplete'">
                      <!-- {{header.value}} {{header.reference}} {{item}} -->
                      <!-- TODO! -->
                      {{ getAutocompleteValue(header, item) }}
                    </span>
                    <span v-else-if="header.type === 'check'">
                      <v-icon
                        v-if="item[header.value] && item[header.value] !== '0'"
                        color="green"
                        >mdi-check</v-icon
                      >
                      <v-icon v-else color="red">mdi-close</v-icon>
                    </span>
                    <span v-else-if="header.click" v-html="item[header.value]" style="cursor: pointer" @click="header.click(item)"> 
                    </span>
                    <span v-else v-html="item[header.value]">
                    </span>


                  </p>
                </td>
                <td style="text-align: center">
                  <div
                    v-for="header in headers"
                    :key="header.value"
                    class="flex-item"
                    data-label="Name"
                  >
                    <div
                      style="min-width: 90px"
                      v-if="header.value === 'actions'"
                      class="text-right"
                    >
                      <v-tooltip
                        v-for="(action, id) in actions"
                        :key="id"
                        top
                      >
                        <template
                          slot="activator"
                          v-if="
                            typeof action.disable !== 'function' ||
                            !action.disable(item)
                          "
                          slot-scope="{ on }"
                        >
                          <a
                            :class="{ 'ml-2': id !== 0 }"
                            flat
                            @click="(evt) => doAction(action, item, evt)"
                          >
                            <v-icon :color="action.color" v-on="on">{{
                              action.icon
                            }}</v-icon>
                          </a>
                        </template>
                        <span>{{ action.text }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-flex
      v-if="modal"
      xs12
      text-right>
      <v-btn
        v-if="modal"
        class="mx-1 font-weight-light"
        color="success"
        small
        @click="$emit('close')"
      >Close</v-btn>
    </v-flex>

  </material-card>
  
</template>
<script>
// import { normalizeFilters } from '@/utils/filters'
import { upsert, getList, remove, getDetail } from '@/api/base_entity'
import { get, upperFirst as uf } from 'lodash'
/**
 * Generic table component getting data from API,
 * supports search, filter, sort, modal upsert, full page upsert
 */
export default {
  name: 'DataTable',
  props: {
    config: { type: Object, default () {} },
    hideUpsert: { type: [Boolean, Number], default: false },
    hideCreate: { type: [Boolean, Number], default: false },
    hideActions: { type: [Boolean, Number], default: false },
    hideBar: { type: Boolean, default: false },
    modal: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    noSearch: { type: Boolean, default: false },
    inlineUpsert: { type: Boolean, default: false },
    hiddenFields: { type: Object, default: () => ({}) },
    filters: { type: Object, default: () => ({}) },
    title: { type: [String, Boolean], default: 'List' },
    upsertTitle: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    apiUpsert: { type: Function, default: upsert },
    apiGetlist: { type: Function, default: getList },
    apiRemove: { type: Function, default: remove },
    apiGetdetail: { type: Function, default: getDetail },
    upsertMaxWidth: { type: String, default: '650px' },
  },
  data () {
    return {
      entityName: this.config.entityName,
      pagination: this.config.pagination,
      loading: true,
      item: Object.assign({}, this.hiddenFields),
      items: [],
      get,
      totalItems: 0,
      defaultSortBy: 'id',
      fields: this.config.fields.map(f => {
        if (f.type !== 'hidden') return f
        if (this.hiddenFields[f.value]) {
          f.value = this.hiddenFields[f.value]
        }
        return f
      }),
      autocompleteItems: {},
      actions: this.config.actions && !this.hideActions && this.config.actions.map(action => {
        if (typeof action === 'string') {
          if (!this.$can(action === 'upsert' ? 'read' : action, this.config.entityName)) return
          return {
            value: action,
            text: action === 'upsert' ? 'Edit ' + this.config.entityName : 'Remove ' + this.config.entityName,
            color: 'primary',
            icon: action === 'upsert' ? (this.$can('upsert', this.config.entityName) ? 'mdi-pencil' : 'mdi-eye') : 'mdi-delete'
          }
        }
        if (!this.$can(action.value === 'upsert' ? 'read' : action.value, this.config.entityName)) return
        return {
          ...action,
          label: action.text || uf(action.value)
        }
      }).filter(a => a),
      localFilters: this.config.filterStorage || {},
      openUpsert: false,
      validForm: false,
      isMobile: false,
    }
  },
  computed: {
    //...mapState('app', ['protocol_id']),
    headers () {
      let headers = this.fields
        .filter(field => field.table)

      if (this.actions.length && !this.hideActions) {
        headers.push({ text: '	Actions	', value: 'actions', table: { sortable: false, align: 'center' }})
      }
      return headers
    },
    // visibleFields () {
    //   return this.fields
    //     .filter(f => typeof f.visible === 'function' ? 
    //       f.visible(this.item, this.$store.state) : typeof f.visible === 'undefined' ? true : f.visible)
    // }
  },
  async created () {
    if(!this.pagination.defaultSortBy) {
      this.pagination.defaultSortBy = this.pagination.sortBy
    }
    this.defaultSortBy = this.pagination.defaultSortBy
    this.getData()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this. onResize)
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    getAutocompleteValue (header, item) {
      if (header.reference && item[header.reference] && item[header.reference][header.title]) {
        return item[header.reference][header.title]
      }

      if (header.value.indexOf('_') !== -1) {
        const k = header.value.split('_')[0]
        if (item[k] && item[k][header.title]) {
          return item[k][header.title]
        }
      }

      return get(item, header.title)

    },
    list (headerList) {
      if (typeof headerList === 'function') {
        return headerList(null, this.$store.state)
      }
      return headerList
    },    
    upsertSaved (item) {
      this.getData()
      this.$emit('saved', item)
    },
    getData (resetPagination = false, withLoading = true) {

      if (resetPagination === true) {
        this.pagination.page = 1
      }

      if (withLoading) {
        this.loading = true
      }

      // ci sono i filtri globali specificati dentro la props `filters` per filtrare
      // il subset da mostrare (ad esempio le drugs di un ordine con id: X)
      // e i filtri locali del cerca che se c'e' un metodo filter specificato
      // nel field lo eseguo (che sono i localFilters)
      
      // const filters = normalizeFilters(Object.assign(this.localFilters, this.filters), this.fields)
      const localFilters = this.fields.filter(f => this.localFilters[f.value] !== undefined && this.localFilters[f.value] !== null)
      let filters = {}
      localFilters.forEach(f => {
         if (typeof f.table.filter === 'function') {
          filters[f.value] = f.table.filter(this.localFilters, this.localFilters[f.value])
        } else if (typeof f.filter === 'function') {
          filters[f.value] = f.filter(this.localFilters, this.localFilters[f.value])
        } else if (f.type === 'autocomplete' && this.localFilters[f.value]) {
          filters[(f.reference || f.value.split('_')[0]) + '.' + f.title] = '%' + this.localFilters[f.value] + '%'
        } else if(!(this.localFilters[f.value] === null || this.localFilters[f.value] === undefined || this.localFilters[f.value] === '')){
          filters[f.value] = '%' + this.localFilters[f.value] + '%'
        }
      })

      filters = Object.assign(filters, this.filters)
      this.$emit('filters', filters)
      
      // la paginazione si chiama itemsPerPage e non piu' rowsPerPage
      this.apiGetlist(this.entityName, filters, {...this.pagination, rowsPerPage: this.pagination.itemsPerPage}).then(data => {
        this.items = data.data
        this.$emit('loaded', this.items, data)
        this.totalItems = data.tot
        this.loading = false
      })
    },
    changeSort (header) {
      if (header.table.sortable === false) return
      this.pagination.page = 1
      if (this.pagination.sortBy === header.value) {
        if (this.pagination.descending === true) {
          this.pagination.sortBy = this.defaultSortBy
        } else {
          this.pagination.descending = !this.pagination.descending
        }
      } else {
        this.pagination.sortBy = header.value
        this.pagination.descending = false
      }
      this.getData()
    },
    save () {
      this.apiUpsert(this.entityName, this.item)
        .then(data => {
          this.item = Object.assign({}, this.hiddenFields)
          this.$refs.form.reset()
          this.$emit('saved', data)
          this.getData()
          this.$root.$emit('openSnackbar', {
            message: (this.config.title || this.title || uf(this.entityName)) + ' updated correctly',
            color: 'success'
          })
        })
        .catch(e => {
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the ' + (this.config.title || this.title || uf(this.entityName)) + ' update. ' +
              e && e.response ? e.response.data.message : 'Error',
            color: 'error'
          })
        })
    },
    // upsert or remove
    doAction (action, item, evt = null) {
      if (evt) { evt.stopPropagation() }
      switch (action.value) {
        case 'upsert':
          this.upsertAction(item)
          this.$nextTick(() => {
            // TOFIX
            this.$root.$emit('itemUpdated')
          })
          break
        case 'remove':
          this.removeAction(item)
          break
        case 'delete':
          this.removeAction(item)
          break
        default:
          this.$emit(action.value, item)
      }
    },
    async removeAction (item) {
      const ret = await this.$root.$confirm.open('Confirm removal', 'Are you sure to remove this item?', { color: 'red' })
      if (ret) {
        if (this.config.id && this.config.id.length>0) {
          item.id = this.config.id.reduce( (ret, id) =>  ret ? ret += `_${item[id]}` : item[id],'')
        }
        this.apiRemove(this.entityName, item)
          .then( () => {
            this.$emit('removed', item)
            this.$root.$emit('openSnackbar', {
              message: (this.config.title || this.title || uf(this.entityName)) + ' removed',
              color: 'success'
            })
            this.getData()
          })
          .catch(e => {
            this.$root.$emit('openSnackbar', {
              message: 'An error occurred during ' + (this.config.title || this.title || uf(this.entityName)) + ' removal: ' +
                e && e.response ? e.response.data.message : 'Error',
              color: 'error'
            })
          })
      }
    },
    upsertAction (item = false) {
      if (!this.config.upsert || this.config.upsert === 'modal') {
        this.item = item && Object.assign({}, item) || { ...this.hiddenFields }
        this.openUpsert = true
      } else {
        if (item) {
          this.$router.push(`/${this.entityName}/${item.id}`)
        } else {
          this.$router.push(`/${this.entityName}/new`)
        }
      }
    }
  }
}
</script>

<style lang="scss">
#dataTable {

  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }
  tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .02);
  }

}

.v-tooltip__content {
  opacity: 1 !important;
  background:white;
}

</style>
